module.exports = __webpack_public_path__ + "static/img/7.f2dc331.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/zh/7.png
// module id = rHpp
// module chunks = 0